enum AuthErrorKey {
	UNAUTHORIZED = 'unauthorized',
	FULL_AUTHENTICATION_REQUIRED = 'Full authentication is required to access this resource',
	ACCESS_DENIED = 'access_denied',
}

export default AuthErrorKey;
